import apiClient from "../clients/apiClient";
import { ApiResponse } from "../schemas/apiResponseSchema";

export interface AccountPaymentAllocationItem {
    transactionId?: number | string | null;
    traNo: string;
    traType?: string | null;
    accountNo?: string | null;
    traAmount?: string | number | null;
    allcamount: string | number;
}

export interface AccountPaymentRequest {
    membercode: string;
    location?: string | null;
    paymode: string;
    allocated: AccountPaymentAllocationItem[];
    party_type: "vendor" | "customer";
    payment_desc?: string | null;
    cheque_no?: string | null;
    card_reference?: string | null;
    other_reference?: string | null;
}

export interface AccountPaymentResponse {
    docnos: string[];
}

export const saveAccountEntriesPayment = async (
    payload: AccountPaymentRequest,
): Promise<AccountPaymentResponse> => {
    try {
        const response: ApiResponse<AccountPaymentResponse> = (
            await apiClient.post("/transactions/account-entries/save", payload, {
                headers: {
                    "x-skip-auth-redirect": "true",
                },
            })
        ).data;

        return response.data;
    } catch (error: any) {
        if (error?.response?.data?.detail) {
            const detail = error.response.data.detail;
            const message = typeof detail === "string" ? detail : JSON.stringify(detail);
            throw new Error(message);
        }

        throw new Error("Failed to save account payment");
    }
};
